import React from 'react'
import PropTypes from 'prop-types'
import { path } from 'ramda'

import { Box, Divider } from '@telus-uds/components-web'

import { components } from '@digital-commerce/shared-utils'

import {
  BreakdownLineItemWrapper,
  HairlineDividerWrapper,
  HeadlessMultipleLineItemNewDesign
} from '../../styles'
import LineItem from '../../LineItem'
import { getFirstBillAmount, getRemainingCredit, parseCredit } from '../../utils'

const FirstBillSection = ({
  translations,
  lang,
  dataTestId,
  hide,
  monthlyBillAmount,
  recurring,
  recurringCredit,
  totalPrice,
  isAuthenticated
}) => {
  const firstBillAmount = getFirstBillAmount(
    path([0, 'recurringBreakdowns', 0, 'total'], recurring),
    recurringCredit
  )

  const remainingCredit = getRemainingCredit(
    recurringCredit,
    path([0, 'recurringBreakdowns', 0, 'total'], recurring),
    path(['oneTime', 'total'])(totalPrice)
  )

  const { ShouldRender } = components

  const remainingCreditCost = parseCredit(remainingCredit)
  const hasRemainingCredit = remainingCreditCost !== 0

  const areFirstBillAndDueMonthlyEqual = monthlyBillAmount === firstBillAmount

  const shouldRenderFirstBillSection = !areFirstBillAndDueMonthlyEqual || hasRemainingCredit

  if (hide || !shouldRenderFirstBillSection) return null

  const firstBillText = isAuthenticated ? translations.nextBill : translations.firstBill

  return (
    <Box>
      <HairlineDividerWrapper>
        <Divider variant={{ decorative: true }} />
      </HairlineDividerWrapper>
      <BreakdownLineItemWrapper>
        <HeadlessMultipleLineItemNewDesign>
          <ShouldRender when={!areFirstBillAndDueMonthlyEqual}>
            <LineItem
              text={firstBillText}
              cost={firstBillAmount}
              lang={lang}
              annotationInline
              dataIdAttribute={`${dataTestId}-price-summary-hs-firstbill`}
            />
          </ShouldRender>
          <ShouldRender when={hasRemainingCredit}>
            <LineItem
              text={translations.remainingBillCredit}
              cost={remainingCreditCost}
              lang={lang}
              annotationInline
              dataIdAttribute={`${dataTestId}-price-summary-hs-remaining-credit`}
            />
          </ShouldRender>
        </HeadlessMultipleLineItemNewDesign>
      </BreakdownLineItemWrapper>
    </Box>
  )
}

FirstBillSection.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
  monthlyBillAmount: PropTypes.number.isRequired,
  recurring: PropTypes.array.isRequired,
  recurringCredit: PropTypes.number.isRequired,
  totalPrice: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  hide: PropTypes.bool
}

FirstBillSection.defaultProps = {
  hide: false
}

export default FirstBillSection
